import React from "react";

const ParallaxSlider = ({backgroundImage}) => {
  return (
    <section
      className="beauty-parallax"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <div className="parallax-overlay"></div>
      <div className="parallax-content">
        {/* Your content here */}
      </div>
    </section>
  );
};

export default ParallaxSlider;
